<template>
  <div class="d-flex align-center justify-space-between">
    <div class="d-flex align-center ga-1">
      <span class="font-weight-bold">Об'єкти делегування</span>
      <span class="text-disabled">({{ delegations.length || 0 }})</span>
    </div>
    <v-btn @click="createDelegation">
      <v-icon class="mr-1">mdi-plus</v-icon>
      Створити
    </v-btn>
  </div>
  <b-global-loader :loading="$loading.isLoading('userDelegationList')">
    <div class="mt-3 d-flex flex-column ga-2">
      <v-card
        v-for="delegation in delegations"
        :key="delegation.id"
        :class="delegation.isActive ? 'opacity-100' : 'opacity-60'"
        border>
        <v-card-text class="d-flex align-center justify-space-between">
          <div class="d-flex align-center ga-2">
            <v-avatar color="indigo-lighten-5" size="40">
              <v-img
                v-if="delegation.delegateUser.photo"
                :src="delegation.delegateUser.photo" />
              <span v-else class="text-indigo-darken-1 font-weight-bold">
                {{
                  delegation.delegateUser.name?.[0] +
                  delegation.delegateUser.surname?.[0]
                }}
              </span>
            </v-avatar>
            <div class="d-flex flex-column">
              <span class="font-weight-bold">{{
                getPersonName(delegation.delegateUser, { initials: true })
              }}</span>
              <span class="text-disabled">
                {{ delegation.assignmentType.name }} ·
                {{ new CustomDate(delegation.startDate).toString() }} —
                {{ new CustomDate(delegation.endDate).toString() }}
              </span>
              <span style="color: #6c6c7d; max-wight: 400px">
                {{ delegation.description || 'Опис відсутній' }}
              </span>
            </div>
          </div>
          <div class="d-flex align-center ga-2">
            <v-chip
              :color="delegation.isActive ? 'success' : 'grey'"
              size="small">
              <span class="font-weight-bold">{{
                delegation.isActive ? 'Активне' : 'Завершено'
              }}</span>
            </v-chip>
            <v-btn
              v-if="delegation.isActive"
              border
              color="white"
              density="comfortable"
              icon
              size="small"
              @click="delegationSettings(delegation)">
              <v-icon color="purple-darken-1" size="small">
                mdi-key-outline
              </v-icon>
            </v-btn>
            <v-btn
              v-if="delegation.isActive"
              :loading="$loading.isLoading('userDelegationDeactivate')"
              border
              color="white"
              size="small"
              @click="deleteDelegation(delegation.id)">
              <span class="font-weight-medium text-error">Видалити</span>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </div>
    <span
      v-if="!delegations.length"
      class="text-disabled d-block text-center mt-5">
      Делегування відсутні
    </span>
  </b-global-loader>
</template>

<script lang="ts">
import { userDelegationDeactivate, userDelegationList } from '@/requests/user'
import { ref } from 'vue'
import { BGlobalLoader } from 'best-modules/components'
import { getPersonName } from 'best-modules/utils/helpers'
import { UserDelegation } from '@/utils/types/user'
import { openDialog } from '@/dialog'
import { CustomDate } from 'best-modules/utils'
import { setSnackbar } from 'best-modules/plugins'

export default {
  name: 'Delegation',
  components: {
    BGlobalLoader,
  },
  methods: { getPersonName, CustomDate },
  setup() {
    const delegations = ref<UserDelegation[]>([])

    const getUserDelegations = () => {
      return userDelegationList().then(res => {
        delegations.value = res
      })
    }

    const setDelegation = (newDelegation: UserDelegation) => {
      const index = delegations.value.findIndex(d => d.id === newDelegation.id)

      if (index !== -1) {
        delegations.value[index] = newDelegation
      }
    }

    const delegationSettings = (delegation: UserDelegation) => {
      return openDialog({
        name: 'DelegationSettings',
        dialogData: {
          delegation: delegation,
          delegationId: delegation.id,
          setDelegation,
        },
        params: {
          hideActionButtons: true,
        },
      })
    }

    const createDelegation = () => {
      return openDialog({
        name: 'DelegationCreate',
        dialogData: { delegations: delegations.value },
        params: {
          cb: newDelegation => {
            delegations.value.push(newDelegation)
            setSnackbar({ text: 'Делегування створено' })
          },
        },
      })
    }

    const deleteDelegation = (delegationId: number) => {
      return userDelegationDeactivate(delegationId).then(() => {
        delegations.value = delegations.value.map(delegation => {
          if (delegation.id === delegationId) {
            return { ...delegation, isActive: false }
          }

          return delegation
        })

        setSnackbar({ text: 'Делегування видалено' })
      })
    }

    getUserDelegations()

    return {
      delegations,
      delegationSettings,
      createDelegation,
      deleteDelegation,
    }
  },
}
</script>

<style lang="scss" scoped></style>
